import { IDemo, EventReplayIds } from 'types'
import { getSharedAsset } from '../utils'
import track from 'assets/captions/public-safety-replay-full.en.vtt'

const poster = getSharedAsset('public-safety-replay-full.png', 'eventReplay', 'posters')
const video = getSharedAsset('public-safety-replay-full.mp4', 'eventReplay', 'videos')
const nextDemoThumbnail = getSharedAsset('public-safety-replay-keynote.png', 'eventReplay', 'thumbnails')

export const fullShow: IDemo = {
  id: EventReplayIds.fullShow,
  poster,
  video,
  tracks: [
    {
      kind: 'captions',
      src: track,
      srcLang: 'en',
      label: 'EN',
      default: false
    }
  ],
  end: {
    header: 'Watch our 6.10 event replay.',
    body: 'Verizon and Public Safety agency experts discuss how First Responders can be supported by 5G.',
    nextDemoId: EventReplayIds.keynote,
    nextDemoText: 'Learn from our experts.',
    nextDemoThumbnail,
    previousDemoId: EventReplayIds.panelDiscussion
  }
}
